import { ChevronRightIcon } from '@heroicons/react/24/outline'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { SectionLinks } from '@src/types/navigation'

type Props = {
  section: SectionLinks
}

export default function SectionLinksColumn({ section }: Props) {
  const { t } = useTranslation('revamp')
  const { title, items, viewMoreLink, link } = section

  return (
    <section className='font-normal'>
      <h4 className='font-bold leading-mid uppercase mb-3'>
        {link ? (
          <a href={link} className='hover:underline'>
            {title}
          </a>
        ) : (
          title
        )}
      </h4>
      <ul className='list-none leading-mid flex flex-col' style={{ gap: '10px' }}>
        {items.map((item) => (
          <li key={`section_${title}_item_${item.title}`}>
            <a href={item.link} className='hover:underline'>
              {item.title}
            </a>
          </li>
        ))}
        {viewMoreLink && (
          <li className='hover:underline mt-4 flex items-center gap-2 font-bold'>
            <a href={viewMoreLink}>{t('viewMore')}</a>
            <ChevronRightIcon className='w-4 h-4' />
          </li>
        )}
      </ul>
    </section>
  )
}
